import { R40Values, R40Result } from './types';

export function calculateR40(values: R40Values): R40Result {
  const { revenueGrowthPercent, profitMarginPercent } = values;

  const rg = isFinite(revenueGrowthPercent) ? revenueGrowthPercent : 0;
  const pm = isFinite(profitMarginPercent) ? profitMarginPercent : 0;
  const score = Math.round((rg + pm) * 100) / 100;
  return { score };
}


